import React, { Component } from 'react'
import PropTypes from 'prop-types'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class LogoutButton extends Component {
    static propTypes = {
        logoutAction: PropTypes.func.isRequired,
    }

    onClickHandler = () => {
        const { logoutAction } = this.props

        logoutAction()
    }

    render() {
        return (
            <div className={'logout-button'} onClick={this.onClickHandler}>
                <svg viewBox={'-40 -40 80 80'}>
                    <path d={'M -6 -15 a 16 16 0 1 0 12 0 l 0 3 a 13 13 0 1 1 -12 0 z'} />
                    <path d={'M -2 0 v -18 h 4 v 18 z'} />
                </svg>
            </div>
        )
    }
}
